export default __webpack_public_path__ + "static/media/search-icon.077696d4.svg";